'use strict';

/*global app*/
/*global services*/
/*global mekrsSetting*/
/*global createObjectCallBack*/
/*global isEmpty*/
/*global resClose*/
/*global resSuccess*/
/*global resError*/

function LocationService() {
  this.modal = null;

  this.init();
}

LocationService.prototype = $.extend({}, {
  constructor: 'LocationService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  loadByBarcode: function loadByBarcode(params, callback) {
    var _this = this;

    app.getFormation('location:load_location_by_barcode', params, function (res) {
      if (res.msg === 'SUCCESS') {
        if (res.data.LocationId) {
          if (res.data.Warning) {
            app.viewErrorMessage(res.data.Warning);

            return callback(resError, res.data);
          } else {
            return callback(resSuccess, res.data);
          }
        }
      }

      return callback(resError, res.data);
    });

    return _this;
  },

  doScanLocation: function doScanLocation(data) {
    var _this = this;

    data = data || {};
    data.Location = $.trim(_this.modal.contentDOM().find('[name="barcode"]').val());

    if (!isEmpty(data.Location)) {
      _this.modal.block();

      var callback = data.callback;

      var params = $.extend({}, data);
      params.callback = null;
      app.getFormation('location:load_location_by_barcode', params, function (res) {
        _this.modal.unBlock();

        if (res.msg === 'SUCCESS') {
          if (res.data.LocationId) {
            _this.modal.close(function () {
              if (res.data.Warning) {
                app.viewErrorMessage(res.data.Warning);

                callback(resError, res.data);
              } else {
                callback(resSuccess, res.data);
              }
            });
          } else {
            app.viewErrorMessage(app.t('location.not_found'));

            _this.modal.contentDOM().find('[name="barcode"]').val('').focus();
          }
        } else {
          app.viewErrorMessage(res.error);
        }
      });
    }

    return _this;
  },

  getScanLocationHtml: function getScanLocationHtml(data) {
    var html = '';
    html += '<p class="text-center">' + app.t('location.scan_location_help') + '</p>';

    if (data && 'Location' in data) {
      html += '<p class="text-center">' + data.Location + '</p>';
    }

    html += '<input type="text" class="form-control k2-keyboard-input--lazy-open " name="barcode" />';

    return html;
  },

  scanLocation: function scanLocation(data, callback) {
    var _this = this;

    data = data || {};
    data.callback = callback;

    _this.modal.open({
      title: app.t('location.scan_location'),
      height: 'auto',
      width: 'md',
      content: _this.getScanLocationHtml(data),
      submitCallBack: createObjectCallBack(_this, 'doScanLocation', data),
      enterSubmitCallBack: createObjectCallBack(_this, 'doScanLocation', data),
      form: true,
      openCallBack: function () {
        _this.modal.contentDOM().find('[name="barcode"]').k2_keyboard_input({ openAfterFocus: false, customButtons: mekrsSetting.keyboardCustomButtons });
        _this.modal.setFocus();
      },

      closeCallBack: function () {
        //pokud bude uspech, bude predefinovano
        callback(resClose, {});
      }
    });

    return _this;
  },

  generateLocation: function generateLocation(params, callback) {
    var _this = this;

    app.getFormation('location:generate_location', params, function (res) {
      if (res.msg === 'SUCCESS') {
        callback(resSuccess, res.data);
      } else {
        if ('error' in res) {
          app.viewErrorMessage(res.error);
        } else {
          app.viewErrorMessage();
        }

        callback(resError);
      }
    });

    return _this;
  },

  findLocation: function findLocation(data, callback) {
    var _this = this;

    $.get(app.path('location_find_location'), data, function (res) {
      if (res.msg === 'SUCCESS') {
        callback(resSuccess, res.data);
      } else {
        if ('error' in res) {
          app.viewErrorMessage(res.error);
        } else {
          app.viewErrorMessage();
        }

        callback(resError);
      }
    });

    return _this;
  },

  getLocationInfo: function getLocationInfo(data, callback) {
    $.get(app.path('location_info', data), function (res) {
      if (res.msg === 'SUCCESS') {
        callback(resSuccess, res.data);
      } else if (res.msg === 'NOT_FOUND') {
        app.viewErrorMessage(app.t('location.not_found'));

        callback(resError);
      } else {
        if ('error' in res) {
          app.viewErrorMessage(res.error);
        } else {
          app.viewErrorMessage();
        }

        callback(resError);
      }
    });
  },

  addUsedLocation: function addUsedLocation(data) {
    $.post(app.path('location_add_used_location'), data, function (res) {
      if (res.msg !== 'SUCCESS') {
        if ('error' in res) {
          app.viewErrorMessage(res.error);
        } else {
          app.viewErrorMessage();
        }
      }
    });
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal-location');

    _this.registerCallbacks();

    return _this;
  }
});
